<template>
  <div class="container">
    <!--Botones de Confirmación y Edición-->
    <div class="d-flex justify-content-end m-2">
      <!--Dropdown de edición-->
      <b-dropdown
        :class="{ ocultarClass: esHome }"
        id="dropdown-1"
        size="sm"
        variant="info"
        text="Editar"
        right
        class="btn-elemento btn-options"
        v-show="showMenu"
        v-on:click=";(showPosition = false), (showAnimation = false)"
      >
        <b-dropdown-item @click="showSrc = true">Subir Audio</b-dropdown-item>
        <b-dropdown-item
          @click="
            showAnimation == true
              ? (showAnimation = false)
              : (showAnimation = true)
          "
        >Agregar animación</b-dropdown-item>
        <b-dropdown-item
          @click="
            showMargin == true ? (showMargin = false) : (showMargin = true)
          "
        >Agregar margen</b-dropdown-item>
        <b-dropdown-item
          @click="
            showPosition == true
              ? (showPosition = false)
              : (showPosition = true)
          "
        >Ajustar posición</b-dropdown-item>
      </b-dropdown>
    </div>
    <div v-show="showAnimation" class="options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar animacion</p>
        </div>
        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div
              @click="addAnimation('fade')"
              class="btn btn-primary py-2 px-2 animation-fade"
            >FadeIn</div>
            <div style="overflow:hidden ">
              <div
                @click="addAnimation('bounce')"
                class="btn btn-warning py-2 px-2 animation-bounce"
              >Bounce</div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <div
                @click="addAnimation('lr')"
                class="btn btn-primary py-2 px-2 animation-slide-l-r"
              >Slide in</div>
            </div>
            <div style="overflow:hidden">
              <div
                @click="addAnimation('rl')"
                class="btn btn-warning py-2 px-2 animation-slide-r-l"
              >Slide in</div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" v-on:click="saveAnimation()" variant="success">Guardar</b-button>
          </div>
        </div>
      </div>
    </div>

    <!--NOTE menu margen-->
    <div v-show="showMargin" class="row">
      <div class="col-8 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar Márgenes</p>
        </div>

        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div style="overflow:hidden ">
              <label for="left">Margen izquierdo</label>
              <input
                v-model.number="localMargin['ml']"
                type="number"
                min="0"
                max="8"
                name="left"
                id
              />
            </div>

            <div style="overflow:hidden ">
              <label for="top">Margen superior</label>
              <input v-model.number="localMargin['mt']" type="number" min="0" max="8" name="top" id />
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <label for="right">Margen derecho</label>
              <input
                v-model.number="localMargin['mr']"
                type="number"
                min="0"
                max="8"
                name="right"
                id
              />
            </div>
            <div style="overflow:hidden">
              <label for="bottom">Margen inferior</label>
              <input v-model.number="localMargin['mb']" type="number" min="0" max="8" name="bottom" />
            </div>
          </div>
        </div>
        <div class="col">
          <div @click="addMargin" class="btn btn-primary m-2">Aplicar</div>

          <div
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            "
            class="btn btn-danger m-2"
          >Cerrar</div>
        </div>
      </div>
    </div>

    <div v-show="showPosition" class="pb-2 options col-6">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Posicionar</p>
        </div>
        <div class="p-3">
          <b-button-group size="sm" class="d-flex flex-row justify-content-center">
            <b-button @click="changePosition('left')" class="mx-4" active variant="outline-success">
              <img src="@/assets/f-left.svg" alt />
            </b-button>
            <b-button @click="changePosition('center')" class="mx-4" variant="outline-info">
              <img src="@/assets/f-center.svg" alt />
            </b-button>
            <b-button @click="changePosition('right')" class="mx-4" variant="outline-warning">
              <img src="@/assets/f-right.svg" alt />
            </b-button>
          </b-button-group>
        </div>
        <div class="d-flex justify-content-end">
          <b-button size="sm" v-on:click="savePosition()" variant="success">Guardar</b-button>
        </div>
      </div>
    </div>
    <div v-show="showSrc" class="col-6 p-3 posicionar-container">
      <div>
        <b-form-file
          size="sm"
          accept="audio/*"
          browse-text="Abrir"
          placeholder="Selecciona el audio"
          :file-name-formatter="setAudio"
        ></b-form-file>
      </div>
      <div class="d-flex justify-content-end pt-3">
        <b-button v-on:click="saveAudio()" size="sm" variant="success">Guardar</b-button>
      </div>
    </div>

    <div class="d-flex" ref="audiocontainer">
      <audio ref="audioref" v-bind:src="src" class="audio-element" controls></audio>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'Audio',
  props: {
    data: Object,
    route: Object,
    idSection: String,
    subid: Number,
    esHome: Boolean,
    online: Boolean,
    elementid: Number
  },
  data() {
    return {
      empty: '',
      showMenu: true,
      showAnimation: false,
      showPosition: false,
      showMargin: false,
      showSrc: false,
      localRoot: null,
      localAudioJSON: null,
      nameAudio: '',
      animation: '',
      position: '',
      src: '',
      isElem: true,
      aaa: null,
      firebaseURL: '',
      localMargin: {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      },
      localPadding: {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
    }
  },
  created() {
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    //Si el audio viene desde la portada
    if (this.route != null) {
      //si esta conectado a internet la src de la img cambia
      if (this.online) {
        this.src = this.localRoot['componentes'][this.route.name][
          this.route.index
        ]['src'][0]['url']
      } else {
        this.src =
          'audios/' +
          this.localRoot['componentes'][this.route.name][this.route.index][
            'src'
          ][0]['name']
      }
      this.animation = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['animation']
      this.position = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['position']
      this.localMargin = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['margin']
      this.localPadding = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['padding']
      this.isElem = false
    } else {
      //Si el audio viene desde un elemento de una sección
      //si esta conectado a internet la src de la img cambia
      if (this.online) {
        this.src = this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['src'][0]['url']
      } else {
        this.src =
          'audios/' +
          this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid]['src'][0]['name']
      }
      this.animation = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid].animation
      this.position = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid].position
      this.localMargin = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['margin']
      this.localPadding = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['padding']

      //  this.localMargin = this.localRoot['componentes']['secciones'][
      //   this.idSection
      // ]['subsecciones'][this.subid]['elements'][this.elementid]['margin']
      // this.localPadding = this.localRoot['componentes']['secciones'][
      //   this.idSection
      // ]['subsecciones'][this.subid]['elements'][this.elementid]['padding']
      this.isElem = true
    }
  },

  mounted() {
    this.$refs.audioref.src = this.src
    this.addAnimation(this.animation)
    this.changePosition(this.position)
    this.addMargin()
    //console.log(this.localAudioJSON)
  },

  methods: {
    addMargin() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      let textElementMargin = this.$refs.audioref
      if (!textElementMargin) {
        return
      }
      textElementMargin.className = ''

      textElementMargin.classList.add('d-flex', 'text-elem')

      textElementMargin.classList.add(
        'pt-' + this.localPadding['pt'],
        'mt-' + this.localMargin['mt']
      )
      textElementMargin.classList.add(
        'pr-' + this.localPadding['pr'],
        'mr-' + this.localMargin['mr']
      )
      textElementMargin.classList.add(
        'pb-' + this.localPadding['pb'],
        'mb-' + this.localMargin['mb']
      )
      textElementMargin.classList.add(
        'pl-' + this.localPadding['pl'],
        'ml-' + this.localMargin['ml']
      )

      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['margin'] = this.localMargin

        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['padding'] = this.localPadding
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'margin'
        ] = this.localMargin
        this.localRoot['componentes'][this.route.name][this.route.index][
          'padding'
        ] = this.localMargin
      }

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))
    },

    setAudio(file) {
      let locationStorage = '/audios/'
      let storageRef = firebase.storage().ref(locationStorage + file[0].name)
      let uploadTask = storageRef.put(file[0])

      uploadTask.on(
        'state_changed',
        snapshot => {
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
              console.log('Upload is paused')
              break
            case firebase.storage.TaskState.RUNNING:
              console.log('Upload is running')
              break
          }
        },
        error => {
          console.log(error)
        },

        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.firebaseURL = downloadURL
            let audioitem = this.$refs.audioref
            audioitem.src = this.firebaseURL
            this.localRoot = JSON.parse(window.localStorage.getItem('root'))
            if (this.isElem) {
              this.localRoot['componentes']['secciones'][this.idSection][
                'subsecciones'
              ][this.subid]['elements'][this.elementid]['src'][0][
                'url'
              ] = this.firebaseURL
              this.localRoot['componentes']['secciones'][this.idSection][
                'subsecciones'
              ][this.subid]['elements'][this.elementid]['src'][0]['name'] =
                file[0].name
            } else {
              this.localRoot['componentes'][this.route.name][this.route.index][
                'src'
              ][0]['url'] = this.firebaseURL
              this.localRoot['componentes'][this.route.name][this.route.index][
                'src'
              ][0]['name'] = file[0].name
            }
            console.log(this.nameAudio)
            let rootToStore = JSON.stringify(this.localRoot)
            window.localStorage.setItem('root', rootToStore)
            this.showSrc = false
            alert('Audio guardado!')
          })
        }
      )

      // let audioitem = this.$refs.audioref
      // this.nameAudio =
      //   'https://firebasestorage.googleapis.com/v0/b/buro-app.appspot.com/o/audios%2F' +
      //   file[0].name +
      //   '?alt=media'
      // audioitem.src = this.nameAudio
      // const urlObj = URL.createObjectURL(file[0])
      // audioitem.addEventListener('load', () => {
      //   URL.revokeObjectURL(urlObj)
      // })
      // console.log('tipo ' + typeof file[0])
      // this.guardar(file[0])
    },

    saveAudio() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['src'][0]['name'] = this.nameAudio
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'src'
        ][0]['name'] = this.nameAudio
      }
      console.log(this.nameAudio)
      let rootToStore = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', rootToStore)
      this.showSrc = false
    },
    guardar(element) {
      // let uploader = this.$refs.myprogressbar
      // this.imagesStorage = this.images
      //let locationStorage = '/z' + 'audios' + '/'
      console.log('entre?')
      // determina si se guardan las imagenes en galeria o carousel
      let storageRef = firebase.storage().ref('/audios/' + element.name)
      let uploadTask = storageRef.put(element)
      //this.promises.push(uploadTask)
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      uploadTask.on(
        'state_changed',
        snapshot => {
          // var progress =
          //   (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          // uploader.value = progress
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
              console.log('Upload is paused')
              break
            case firebase.storage.TaskState.RUNNING:
              console.log('Upload is running')
              break
          }
        },
        error => {
          console.log(error)
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            console.log(downloadURL)
            /*let obj = {}
              obj.name = element.name
              obj.src = downloadURL
              this.namesAndURLS.push(obj)*/
          })
        }
      )
    },
    addAnimation(type) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.animation = ''
      switch (type) {
        case 'rl':
          /*this.$refs.audioref.classList.remove('animation-slide-l-r')
          this.$refs.audioref.classList.remove('animation-bounce')
          this.$refs.audioref.classList.remove('animation-fade')
          this.$refs.audioref.classList.add('animation-slide-r-l')*/
          this.animation = 'rl'
          break
        case 'lr':
          /* this.$refs.audioref.classList.remove('animation-slide-r-l')
          this.$refs.audioref.classList.remove('animation-bounce')
          this.$refs.audioref.classList.remove('animation-fade')
          this.$refs.audioref.classList.add('animation-slide-l-r')*/
          this.animation = 'lr'
          break
        case 'bounce':
          /*this.$refs.audioref.classList.remove('animation-slide-l-r')
          this.$refs.audioref.classList.remove('animation-slide-r-l')
          this.$refs.audioref.classList.remove('animation-fade')
          this.$refs.audioref.classList.add('animation-bounce')*/
          this.animation = 'bounce'
          break
        case 'fade':
          this.animation = 'fade'
          break
        default:
          break
      }
    },
    saveAnimation() {
      this.showAnimation = false
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection].subsecciones[
          this.subid
        ]['animation'] = this.animation
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'animation'
        ] = this.animation
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    changePosition(position) {
      this.position = ''
      switch (position) {
        case 'left':
          this.$refs.audiocontainer.classList.remove('justify-content-end')
          this.$refs.audiocontainer.classList.remove('justify-content-center')
          this.$refs.audiocontainer.classList.add('justify-content-start')
          this.position = 'left'
          break
        case 'center':
          this.$refs.audiocontainer.classList.remove('justify-content-start')
          this.$refs.audiocontainer.classList.remove('justify-content-end')
          this.$refs.audiocontainer.classList.add('justify-content-center')
          this.position = 'center'
          break
        case 'right':
          this.$refs.audiocontainer.classList.remove('justify-content-start')
          this.$refs.audiocontainer.classList.remove('justify-content-center')
          this.$refs.audiocontainer.classList.add('justify-content-end')
          this.position = 'right'
          break
        default:
          break
      }
    },
    savePosition() {
      this.showPosition = false
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.isElem) {
        //console.log("algo")
        this.localRoot['componentes']['secciones'][this.idSection].subsecciones[
          this.subid
        ]['position'] = this.position
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'position'
        ] = this.position
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style scoped>
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}

.audio-element {
  position: relative;
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}

/*Animación y posición de la imagen*/
.base-animation {
  opacity: 1;
}
.fade-in {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-delay: 0;
  animation-play-state: running;
}

.animation-fade {
  animation-name: fadeIn;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-play-state: running;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-slide-r-l {
  position: relative;
  animation-name: sliderl;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-bounce {
  position: relative;
  animation-name: bounce;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: none;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}
.posicionar-titulo {
  /* background-color: antiquewhite; */
  border-bottom: solid #b1b0b0 2px;
  border-radius: 8px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}
@keyframes sliderl {
  from {
    left: 3em;
    opacity: 0;
  }
  to {
    left: 0em;
    opacity: 1;
  }
}
@keyframes bounce {
  from {
    bottom: 2.5em;
    opacity: 0;
  }
  to {
    bottom: 0em;
    opacity: 1;
  }
}
</style>
